import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-cmdb-sync-history-skeleton',
  templateUrl: './cmdb-sync-history-skeleton.component.html',
  styleUrls: ['./cmdb-sync-history-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class CmdbSyncHistorySkeletonComponent {
  readonly tableRows = [1, 2, 3, 4, 5, 6];
  readonly tableCols = [1, 2, 3, 4, 5, 6];
}